import React from "react";
import {Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon, ChevronUpIcon, ChevronDownIcon} from "@heroicons/react/24/outline";

export function TableHead({
                            tableHead,
                            headSortable,
                            headMap,
                            sortType,
                            setSortType,
                            setSortBy,
                            selectedHead,
                            setSelectedHead
                          }) {

  const handle_sort = (head) => {
    if (headSortable[head] === true) {
      if (head === selectedHead) {
        setSortType(!sortType);
      } else {
        setSortType(false);
        setSortBy(headMap[head]);
      }
      setSelectedHead(head);
    }
  };

  const getSortIcon = (head) => {
    if (!headSortable[head]) return null;
    if (head !== selectedHead) return <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 text-app-subtle" />;
    return sortType
      ? <ChevronUpIcon strokeWidth={2} className="h-4 w-4 text-app-text" />
      : <ChevronDownIcon strokeWidth={2} className="h-4 w-4 text-app-text" />;
  };

  return (
    <thead className="w-full py-8">
      <tr className="w-full py-8">
        {tableHead.map((head) => (
          <th
            key={head}
            onClick={() => handle_sort(head)}
            className={`select-none border-b border-app-border bg-app-muted/70 px-2 py-4 transition-colors ${
              headSortable[head] ? "cursor-pointer hover:bg-app-primary-soft" : ""
            }`}
          >
            <div className="flex flex-row items-center justify-center gap-1 px-2">
              <Typography
                variant="small"
                className="textCenter font-normal leading-none text-app-text-muted"
              >
                {head}
              </Typography>
              {getSortIcon(head)}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
}
